export default __webpack_public_path__ + "static/media/echelon-leaderboard.67ce4665.svg";